import React, {PureComponent} from 'react';
//import ReactDOM from 'react-dom';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd'

class Draggables extends PureComponent {

  state = {
    id: null,
    items: [],
  }

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = this.reorder(
      this.props.items,
      result.source.index,
      result.destination.index
    );
    this.setState({items})
    if(this.props.onDragEnd){
      this.props.onDragEnd(items);
    }
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  componentWillMount(){
    const id = this.props.id || `droppable-${Math.floor((Math.random() * 99999999)).toString()}`;
    const items = this.props.items || [];
    this.setState({id, items});
    // let portal = document.createElement("div");
    // document.body.appendChild(portal);
  }

  render() {


    // function MyDraggableItem_render(props) {
    //   let result = (
    //     <div>[...]</div>
    //   );
    //
    //   if (props.snapshot.isDragging) {
    //     return ReactDOM.createPortal(result, portal);
    //   }
    //   return result;
    // }

    const {children, locked} = this.props;
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId={this.state.id} direction={"vertical"}>
        {(provided, snapshot) => (
          <div ref={provided.innerRef} >
          {React.Children.map(children,(item, index) => {
            const id = item.props.data ? item.props.data.index || index : item.props.index || index;
            return (
            <Draggable key={index} draggableId={"draggable"+id} isDragDisabled={locked} index={index}>
            {(provided, snapshot) =>
              <div ref={provided.innerRef}{...provided.draggableProps}{...provided.dragHandleProps}>
                {item}
              </div>
            }
            </Draggable>
            )
          })}
        {provided.placeholder}
        </div>
        )}
        </Droppable>
      </DragDropContext>
    )
  }
}

export default Draggables;
